import { render, staticRenderFns } from "./daka_index_btn.vue?vue&type=template&id=b9162456&scoped=true"
import script from "./daka_index_btn.vue?vue&type=script&lang=js"
export * from "./daka_index_btn.vue?vue&type=script&lang=js"
import style0 from "./daka_index_btn.vue?vue&type=style&index=0&id=b9162456&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9162456",
  null
  
)

export default component.exports